<tracker-detail-metric
  [metricForm]="metricForm"
  [editing]="!!data?.metric"
  [trackerDetail]="true"
  (dateTimePickerChange)="onDateTimePickerChange($any($event))"
></tracker-detail-metric>

@if (!dateTimePickerOpen()) {
  <footer>
    <oph-button appearance="outline" color="gray" [style]="{color: 'var(--brown-med)'}" (buttonClick)="onClose()"
      >Cancel</oph-button
    >
    <oph-button color="green" (buttonClick)="onAddMetric()" [disabled]="!valid()" [loading]="loading()"
      >Save</oph-button
    >
  </footer>
}
